export default "__VITE_ASSET__9oIDBYpG__"